import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ExtranetModule } from './extranet-module.enum';
import { ModuleClaimMap } from './module-claim-map';

const usersRolesClaim = 'extranet_modules_users_roles';
const adminRoleClaimValue = 'Admin';
@Injectable({
  providedIn: 'root'
})
export class ModuleAccessService {

  constructor(private oauthService: OAuthService) { }

  public currentUserHasAccessTo(module: ExtranetModule): boolean {
    if (module == ExtranetModule.Users) {
      return this.currentUserHasClaimWithValue(usersRolesClaim, adminRoleClaimValue);
    }
    let claims = this.oauthService.getIdentityClaims();
    if (claims == null)
      return false;

    if (module === ExtranetModule.All) {
      return true;
    }

    let accessClaim = Boolean(claims[ModuleClaimMap.get(module)]);
    return accessClaim === true;
  }

  private currentUserHasClaimWithValue(claimType: string, claimValue: string) {
    let claims = this.oauthService.getIdentityClaims();
    if (claims == null) {
      return false;
    }

    return claims[claimType] === claimValue;
  }
}
